import WelcomeHero from 'flarum/forum/components/WelcomeHero';
import { override } from 'flarum/common/extend';
import ItemList from 'flarum/common/utils/ItemList';
import { assetUrl } from '../common/utils/assets';
export function installCustomWelcomeHero() {
  override(WelcomeHero.prototype, 'className', className => {
    return className() + ' CustomWelcomeHero';
  });
  override(WelcomeHero.prototype, 'viewItems', items => {
    const dummy = new ItemList();
    dummy.add('justImage', m("img", {
      class: "logo",
      alt: "Parafia pw. Matki Teresy z Kalkuty",
      "aria-hidden": "true",
      src: assetUrl('image/Parish_forum_banner_Polish_text_202606281817.png')
    }));
    return dummy;
  });
}
export default {};